export default __webpack_public_path__ + "assets/spaceIndustrial.7f616c54.png";